import { showNotification } from "@mantine/notifications";
import { MedplumClient } from "@medplum/core";

const bulkHandler = async (medplum: MedplumClient, payload: any) => {
    try {
        const res = await medplum.executeBot(
            {
                system: 'https://api-stage.healthconnect.systems/bots',
                value: 'bulk-service'
            }
            , payload);
        return res;
    } catch (err) {
        console.error("Unexpected error:", err);
    }
}

const getBulkClientList = async (medplum: MedplumClient) => {
    const clientList = await medplum.searchResources('ClientApplication', { 'name:contains': 'backend' })
    return clientList.map((item: any) => {
        
        return { clientId: item.id, name: item.name }
    })
}
const bulkKickOff = async (medplum: MedplumClient, payload: any) => {
    const res = await bulkHandler(medplum, { ...payload, request: 'bulk_kickoff' });
    return res;
}

const bulkStatus = async (medplum: MedplumClient, setProgress: any, payload: any) => {
    let tmpProgress = 10
    // const res = await bulkHandler(medplum, { request: 'bulk_status', ...payload });
    // if (res?.body?.bulk_status?.progress) {
    //     const progressArr = res?.body?.bulk_status?.progress.split(' ')
    //     const total = 
    //     setProgress({ progress: parseInt(progressArr[1]), total: parseInt(progressArr[3]) })
    // }

    return await new Promise((resolve) => {
        const interval = setInterval(async () => {
            const res = await bulkHandler(medplum, { request: 'bulk_status', ...payload });
            // const progressArr = res?.body?.bulk_status?.progress.split(' ')
            if (tmpProgress<90) tmpProgress = tmpProgress + 10
            if (res?.status === 500 ) {
                showNotification({ message: 'Bulk export failed: '+res?.body?.error, color: 'red' })
                resolve(res?.status)
                clearInterval(interval)
                return
            }
            // const progress = tmpProgress > parseInt(progressArr[1])  
            //     ? tmpProgress
            //     : parseInt(progressArr[1])
            // if (progress < parseInt(progressArr[3]) - 1) tmpProgress = progress + 1;
            
            setProgress({ progress: tmpProgress, total: 100 })
            if (res?.body?.bulk_status && !res?.body?.bulk_status?.progress) {
                resolve(res?.body?.bulk_status)
                clearInterval(interval)
                return
            }
        }, 4000)
    })

}

const downloadFile = async (medplum: MedplumClient, payload: any, name:string) => {
    const res = await bulkHandler(medplum, { ...payload, request: 'bulk_file' });
    if (res?.body?.bulk_file) {
        return JSON.parse(atob(res?.body?.bulk_file))
        // const url = URL.createObjectURL(new Blob([atob(res?.body?.bulk_file)], { type: 'application/json' }));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', `${name}.json`);
        // document.body.appendChild(link);
        // link.click();
    }
}

const getFileDataCount = async (medplum: MedplumClient, fileList: any, endpoint: string, clientId: string) => {
    const filePromiseArray = fileList.reduce((acc: any, item: any) => {
        const payload = {
            contentUrl: item.url,
            endpointId: endpoint,
            clientId
          }
        acc.push(bulkHandler(medplum, { ...payload, request: 'bulk_file' }))
        return acc
    }, [])
    const res = await Promise.all(filePromiseArray)
    return res.map((i)=>JSON.parse(atob(i?.body?.bulk_file))?.length)
    
}





export { bulkKickOff, getBulkClientList, bulkStatus, downloadFile, getFileDataCount }